import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import '@/styles/index.scss' // global css
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control
import moment from 'moment'
import i18n from './lang/index'
// 引入echarts
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
// main.js 中可以全局设置 点击空白处、按下ESC不能关闭Dialog弹窗
// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
// 全局修改默认配置，按下ESC不能关闭弹窗
ElementUI.Dialog.props.closeOnPressEscape.default = false
/**
 * @MethodAuthor: YuanZheLi
 * @Date: 2022-01-10 15:27:00
 * @Description: 统一格式化去除input首尾空格
 */
Vue.component('el-input', {
  extends: ElementUI.Input,
  created() {
    this.$on('change', (value) => {
      this.$emit('input', value.trim())
    })
  }
})

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.$moment = moment
Vue.use(ElementUI, {
  locale
})
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  //  全局事件总线
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  components: {
    App
  },
})



// WEBPACK FOOTER //
// ./src/main.js